import type { ProductsType } from 'redux-store/slices/products/types';
import getDiscountedPrice from 'redux-store/slices/products/utils/getDiscountedPrice';

export default function getYearPrice(products: ProductsType): {
  price: number;
  discountedPrice: string | number;
  totalYearPrice: string | number;
} {
  let price = 0;
  let totalYearPrice: string | number = 0;
  let discountedPrice: string | number = 0;
  const yearProduct = products.find(product => product.interval === 'year');

  if (yearProduct) {
    price = yearProduct.price;
    discountedPrice = getDiscountedPrice(price, yearProduct.discount);
    totalYearPrice = discountedPrice;

    if (
      products.length === 2 &&
      products[0].interval === 'month' &&
      products[1].interval === 'year'
    ) {
      price = +(price / 12).toFixed(2);
      discountedPrice = getDiscountedPrice(price, yearProduct.discount);
    }
  }

  return { price, discountedPrice, totalYearPrice };
}
